import PersonalizedRecommendations from "th/personalizedRecommendations";

export { PersonalizedRecommendations };

customElements.define(
  "th-personalized-recommendations",
  PersonalizedRecommendations.CustomElementConstructor
);
